import React, {useEffect, useRef} from 'react'
import numeral from 'numeral'
import QRCodeStyling from 'qr-code-styling'
import {useTranslation} from 'react-i18next'
import {Form, Typography} from 'antd'
import {getQrConfig} from './services'
import {logo} from '@/pages/PayByLink/components/PaymentLinkDetailsModal/components/LinkPdfPreview/constants'
import {LinkPdfPreviewProps} from './props'

import styles from '@/pages/PayByLink/components/PaymentLinkDetailsModal/components/LinkPdfPreview/styles.scss'

export const LinkPdfPreview: React.FC<LinkPdfPreviewProps> = ({paymentLink, form}) => {
    const {t} = useTranslation()
    const ref = useRef(null)
    const {url, amount, currency} = paymentLink
    const displayName = Form.useWatch<string>('displayName', form)
    const description = Form.useWatch<string>('description', form)
    const config = getQrConfig(url)

    const qrCode = new QRCodeStyling(config)

    useEffect(() => {
        qrCode.append(ref.current)
    }, [])

    useEffect(() => {
        qrCode.update({
            data: url
        })
    }, [url])

    return (
        <>
            <Typography.Text className={styles.labels}>{t('LinkPdfPreview.title')}</Typography.Text>

            <div className={styles.root}>
                <div className={styles.header}>{t('PaymentLinkDownloadPdfButton.scanToPay')}</div>
                <div className={styles.name}>
                    {displayName?.trim() || t('PaymentLinkDownloadPdfButton.merchantName')}
                </div>{' '}
                {(Boolean(amount) || Boolean(description)) && (
                    <div className={styles.amountHolder}>
                        {Boolean(amount) && (
                            <div className={styles.amount}>
                                {numeral(amount).format('0.00')}{' '}
                                <span className={styles.currency}>{currency}</span>
                            </div>
                        )}

                        {Boolean(description) && (
                            <div className={styles.discription}>{description?.trim()}</div>
                        )}
                    </div>
                )}
                <div className={styles.qr}>
                    <div ref={ref} />
                </div>
                <div className={styles.footer}>
                    <div className={styles.poweredBy}>
                        {t('PaymentLinkDownloadPdfButton.poweredBy')}
                    </div>
                    <img className={styles.logo} src={logo} />
                </div>
            </div>
        </>
    )
}
